<h2 mat-dialog-title class="dialog-header">
    <span class="title-large">Modifica prezzo</span>

    <button
        mat-icon-button
        type="button"
        aria-label="Chiudi"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="content">
    <span class="body-medium emphasized product-name">{{ data.nomeProdotto }}</span>

    <div class="price-row">
        <label class="body-medium" for="edit-price-input">Prezzo unitario:</label>
        <input
            id="edit-price-input"
            class="body-medium emphasized price-value"
            type="number"
            min="0"
            step="0.01"
            [value]="price()"
            (change)="onPriceInput($any($event.target).value)"
        />
        @if (data.unitaMisura) {
            <span class="body-medium">/ {{ data.unitaMisura }}</span>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton="filled" type="button" (click)="onConfirm()">Conferma</button>
</mat-dialog-actions>
